import { render, staticRenderFns } from "./GradingCriteria.vue?vue&type=template&id=83d638a6&scoped=true"
import script from "./GradingCriteria.vue?vue&type=script&lang=js"
export * from "./GradingCriteria.vue?vue&type=script&lang=js"
import style0 from "./GradingCriteria.vue?vue&type=style&index=0&id=83d638a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d638a6",
  null
  
)

export default component.exports